import APIClient from '../services/APIClient';
import { appendInlineParams } from './helper';

export class ChargersTask {
  cancel = (inlineParams = {}) => APIClient.post(appendInlineParams('/chargers/:chargerId/control/tasks/:taskId/cancel', inlineParams));

  upload = (inlineParams = {}) => APIClient.post(appendInlineParams('/chargers/:chargerId/control/tasks/:taskId/upload', inlineParams));

  download = (inlineParams = {}) => APIClient.get(appendInlineParams('/chargers/:chargerId/control/tasks/:taskId/download', inlineParams));

  interactions = (inlineParams = {}) => APIClient.get(appendInlineParams('/chargers/:chargerId/control/interactions', inlineParams));

  create = (inlineParams = {}, bodyParams = {}) => APIClient.post(appendInlineParams('/chargers/:chargerId/control/tasks', inlineParams), bodyParams);
}

export default new ChargersTask();
